import React from 'react';
import { useTheme } from 'styled-components';

import { IAppTheme } from '../../styles/IAppTheme';
import { BannerSVG, BannerSVGProps } from './BannerSVG';

export interface ChatBackgroundSVGProps extends Pick<BannerSVGProps, 'primaryFillHexColor'> {
  /** Additional CSS class names */
  className?: string;
}

/**
 * ChatBackgroundSVG Component
 * 
 * Wrapper around BannerSVG configured for main chat area background.
 * Creates a decorative wave pattern behind chat messages.
 * Uses theme primary color by default.
 * 
 * Features:
 * - Positioned absolutely to not affect layout
 * - Behind content (z-index: -1)
 * - Full width and height of container
 * - Pointer events disabled
 * 
 * @example
 * ```tsx
 * <div style={{ position: 'relative' }}>
 *   <ChatBackgroundSVG />
 *   <div>Chat content here</div>
 * </div>
 * ```
 */
export const ChatBackgroundSVG: React.FC<ChatBackgroundSVGProps> = ({
  className = '',
}) => {
  const theme = useTheme() as IAppTheme;
  const fillColor = theme.color.chatPanelBG;

  return (
    <div
      className={`wave-background ${className}`.trim()}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
      aria-hidden="true"
    >
      <BannerSVG
        primaryFillHexColor={fillColor}
        viewBox="0 0 1600 250"
        preserveAspectRatio="xMidYMid slice"
      />
    </div>
  );
};

export default ChatBackgroundSVG;

